import React from 'react'
import {MdAdd, MdClose, MdDelete, MdDone, MdHealing, MdNotifications, MdPerson} from 'react-icons/md';
import {Badge, Button, Media} from "reactstrap";

import LocalizedStrings from "react-localization";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import ReactTooltip from "react-tooltip";
import placeholderHelper from "../../helpers/PlaceholderHelper";
import dateHelpers from "../../helpers/DateHelper";
import {isSafari} from "react-device-detect";

const roundButton = {width: 50, height: 50, minWidth: 50, minHeight: 50, borderRadius: 25, padding: 0}

let commonStrings = new LocalizedStrings(common_strings);
let studentStrings = new LocalizedStrings(student_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const propTypes = {};

class ClientInClassTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            client: props.client,
            confirmedBooking: props.confirmedBooking,
            classTickets: props.classTickets,
        };
    }

    showClientPreview = this.showClientPreview.bind(this);

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.classTickets !== this.state.classTickets) {
            this.setState({classTickets: nextProps.classTickets})
        }
        if (nextProps.yclass !== this.state.yclass) {
            this.setState({yclass: nextProps.yclass})
        }
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    render() {
        this.localize();
        return (

            <div className={(this.props.isWaiting || this.props.isCancelled) ? "table-light" : ""}
                 style={{
                     backgroundColor: this.props.isWaiting || this.props.isCancelled ? "white" : "#ecebeb",
                     display: "flex",
                     flexFlow: "row",
                     justifyContent: "space-between",
                     alignItems: "center",
                     width: "100%",
                     margin: 10,
                     flexWrap: "wrap",
                     padding: 20,
                     borderRadius: 50
                 }}>
                <div>
                    <Media className="align-items-center" onClick={e => this.showClientPreview(e, this.state.client)} style={{cursor: "pointer"}}>
                        <a
                            className="avatar mr-3"
                            style={{backgroundColor: this.state.client && this.ticketData() !== null ? "rgba(19,102,32,0.68)" : "rgba(193,25,25,0.68)", padding: 2}}
                            onClick={e => e.preventDefault()}
                        >
                            <img
                                alt="..."
                                style={{objectFit: "cover", imageOrientation: "from-image"}}
                                src={this.state.client && this.state.client.photo ? this.state.client.photo : placeholderHelper.randomIcon()}
                            />
                        </a>
                        <div style={{display: "flex", flexFlow: "column"}}>
                            <div style={{
                                fontWeight: 600, display: "flex", flexFlow: "row",
                                color: `${this.props.isCancelled || this.props.isWaiting ? "black" : "#3b4b5f"}`
                            }}>
                                {this.state.client && this.state.client.name ? this.state.client.name : ""}

                                <div className="ml-2">
                                    {this.state.client && (this.props.isBooking || this.props.isCancelled || this.props.isWaiting) &&
                                    <Badge style={{color: "white", marginLeft: "3px", marginTop: "2px", background: this.props.isBooking ? "rgba(12,61,75,0.92)" : (this.props.isCancelled ? "rgba(159,62,58,0.92)" : "rgba(144,102,137,0.92)")}}
                                           className="btn-icon"
                                           color={this.props.isBooking ? "default" : "warning"}
                                           data-type="error"
                                           data-tip={this.popupBookingStateText()}
                                           onClick={e => this.handleStatusButtonClick(e)}
                                           size="xs">
                                        {this.props.isBooking ? 'OPEN CLIENT' : this.props.isWaiting ? commonStrings.waiting : commonStrings.cancelled}
                                        {this.props.cancellation_data && this.props.cancellation_data.timestamp &&
                                            // <span style={{marginLeft: 6}}><br/>{this.props.cancellation_data.timestamp.replace('T', " ")}</span>
                                            <span style={{marginLeft: 6}}><br/>{dateHelpers.fullDisplayTimestamp(new Date(this.props.cancellation_data.timestamp))}</span>
                                        }
                                    </Badge>
                                    }

                                    {this.props.confirmedBooking &&
                                    <Badge style={{color: "white", marginLeft: "3px", marginTop: "2px", background: "rgba(91,123,93,0.92)"}}
                                           className="btn-icon"
                                           color="success"
                                           data-type="success"
                                           data-tip={this.popupConfirmedBookingStateText()}
                                           onClick={e => e.preventDefault()}
                                           size="xs">
                                        {resourceStrings.confirmed_booking}
                                    </Badge>
                                    }
                                </div>
                            </div>

                            <div>
                                {this.state.client && this.ticketData() !== null ?
                                    (<Badge color="" className="badge-dot" style={{fontWeight: 600, fontSize: "0.8rem"}}>
                                        <i className="bg-success"/>
                                        {this.ticketData()}
                                    </Badge>) :
                                    (
                                        <Badge color="" className="badge-dot mr-4">
                                            <i className="bg-warning"/>
                                            {resourceStrings.no_ticket_for_class}
                                        </Badge>
                                    )
                                }
                            </div>

                            <small>
                                <div style={{
                                    color: "#6d7071",
                                    maxWidth: '20rem',
                                    overflow: 'hidden',
                                    textOverflow: "ellipsis"
                                }}>
                                    {this.state.client && this.state.client.note ? this.state.client.note : ""}
                                </div>
                            </small>
                        </div>

                    </Media>

                    <div className="align-items-center ml-6">

                    </div>
                </div>

                {!isSafari &&
                    <ReactTooltip/>
                }

                <div className="text-right align-content-end">
                    {this.state.client && this.props.isCancelled !== true && this.props.isWaiting !== true &&
                    <div>
                        <Button
                            style={roundButton}
                            className="btn-icon ct-example-tooltip-static"
                            color={this.props.confirmedBooking ? "danger" : "success"}
                            data-type="error"
                            data-tip={this.props.confirmedBooking ? resourceStrings.unconfirm_attendance : resourceStrings.confirm_attendance}
                            onClick={e => this.props.confirmedBooking ? this.props.unconfirmBooking(e, this.state.client) : this.props.confirmBooking(e, this.state.client)}>
                            {this.props.confirmedBooking ?
                                (<MdClose/>) : (<MdDone/>)
                            }
                        </Button>
                        <Button
                            style={roundButton}
                            className="btn-icon ct-example-tooltip-static"
                            color="warning"
                            data-type="error"
                            data-tip={studentStrings.remove_from_class}
                            onClick={e => this.props.deleteClient(e, this.state.client)}>
                            <MdDelete/>
                        </Button>
                        <Button
                            style={roundButton}
                            color="secondary"
                            data-type="info"
                            data-tip={studentStrings.view_client}
                            onClick={e => this.showClientPreview(e, this.state.client)}>
                            <MdPerson/>
                        </Button>
                        {this.state.client && this.state.client.reminders && this.state.client.reminders.length > 0 &&
                        <Button
                            style={roundButton}
                            color="danger"
                            data-type="info"
                            data-tip={studentStrings.view_client}
                            onClick={e => this.showClientPreview(e, this.state.client)}>
                            <MdNotifications/>
                        </Button>
                        }
                        {this.ticketData() == null &&
                        <Button
                            style={roundButton}
                            color="default"
                            data-type="success"
                            data-tip={resourceStrings.add_ticket}
                            onClick={e => this.props.showTicketTypes(e, this.state.client.id)}>
                            <MdAdd/>
                        </Button>
                        }
                        {this.state.client.inj &&
                        <Button
                            style={roundButton}
                            color="danger"
                            data-type="info"
                            data-tip={studentStrings.view_client}
                            onClick={e => this.showClientPreview(e, this.state.client)}>
                            <MdHealing/>
                        </Button>
                        }
                    </div>
                    }
                </div>
            </div>
        )
    }

    ticketData() {
        if (this.props.freeClass) {
            return resourceStrings.free_class
        } else {
            if (this.state.classTickets) {
                const ticket = this.state.classTickets.find(t => t.student_id === this.state.client.id);

                if (ticket) {
                    return ticket.name + " " + `(${ticket.id})`
                } else return null

            } else return null
        }
    }

    popupConfirmedBookingStateText() {
        return resourceStrings.attendance_confirmed_expl
    }

    popupBookingStateText() {
        if (this.props.isBooking) {
            return studentStrings.registered_from_client_app
        } else if (this.props.isWaiting) {
            return studentStrings.waiting_expl
        } else if (this.props.isCancelled) {
            return studentStrings.cancelled_expl
        }
    }

    handleStatusButtonClick(e) {
        e.preventDefault();
    }

    showClientPreview(ev, client) {
        ev.preventDefault();

        this.props.showClientPreview(client)
    }

}

ClientInClassTableRow.propTypes = propTypes;

export default ClientInClassTableRow;